function bmHeader5Searchform() {
	jQuery( ".bm-Header--5 .searchform-show" ).click(function() {
		jQuery( ".bm-Header--5__Searchform" ).toggleClass('d-flex');
	});
}

window.addEventListener('load', bmHeader5Searchform);